import { Box, Text } from '@chakra-ui/react';

type Step2SectionValidationErrorProps = {
  sectionId: string;
  message: string | undefined;
  show: boolean;
};

export function Step2SectionValidationError({
  sectionId,
  message,
  show,
}: Step2SectionValidationErrorProps) {
  if (!show || message === undefined || message === '') {
    return null;
  }

  return (
    <Box data-validation-error data-section={sectionId} mt={2}>
      <Text color="red.500" fontSize="sm">
        * {message}
      </Text>
    </Box>
  );
}
